import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/creators/{creatorId}/confido-bank-accounts']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getConfidoBankAccounts = async ({ creatorId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/creators/{creatorId}/confido-bank-accounts', { creatorId });
  const data = await noodleApiClient.get(path);
  return data.data;
};

export default getConfidoBankAccounts;